<div
  [ngClass]="'help-icon'"
  #tooltip="matTooltip"
  [matTooltipClass]="'help-icon '  + className"
  [matTooltip]="message"
  matTooltipPosition="above"
></div>
